// extracted by mini-css-extract-plugin
export default {"container":"T4-z","list":"U4-z"};